import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import SpinLoader from '../../../UI/Loader/SpinLoader';
import { fmtDay } from '../../epmHelpers';
import { CHECKLIST_PROFILE } from '../../checklists';
import ChecklistAuditTable from './ChecklistAuditTable';
import { marker } from './utils';

const StagingChecklist = ({
    stagingItems = [],
    stagingSigned = false,
    isChecklistsLoading = false,
    isStagingChecked,
    toggleStaging,
    canUpdate = true,
    boundDay,
    stagingAudits = [],
    checklistLookup = {},
    currentUserId,
    currentUserName,
}) => {
    const [stagingOpen, setStagingOpen] = useState(!stagingSigned);
    const [stagingAuditOpen, setStagingAuditOpen] = useState(false);

    return (
        <div className="epm-plan__collapsible" id="epm-staging-checklist">
            <div
                className={`epm-plan__collapsible-header relative ${stagingOpen ? 'is-open' : ''}`}
                onClick={() => setStagingOpen(!stagingOpen)}
            >
                <ChevronDown size={16} />
                <span className="epm-plan__collapsible-title text-sm">Staging</span>
                <span className="epm-plan__collapsible-subtitle text-xs"></span>
                <span className="epm-plan__collapsible-action">Checklist</span>
            </div>
            {stagingOpen && (
                <div className="epm-plan__collapsible-body">
                    {isChecklistsLoading ? (
                        <div className="flex items-center justify-center py-6 text-xs text-[#8992a8] gap-2">
                            <SpinLoader className="w-4 h-4 text-[#8992a8]" />
                            <span>Loading checklist items...</span>
                        </div>
                    ) : (
                        <>
                            {stagingItems.map((item, index) => {
                                const isChecked = isStagingChecked(item, index);
                                return (
                                    <div
                                        key={item.id || item._id || index}
                                        className={`epm-build__ck ${!isChecked ? 'open' : ''}`}
                                    >
                                        <input
                                            type="checkbox"
                                            className="epm-build__checkbox"
                                            checked={isChecked}
                                            disabled={stagingSigned || !canUpdate}
                                            onChange={() => toggleStaging(item, index)}
                                            aria-label={item.label}
                                        />
                                        <span>
                                            {item.label}
                                            {item.detail && <span className="epm-build__detail">{item.detail}</span>}
                                        </span>
                                        <span className="epm-build__req">{marker(item)}</span>
                                    </div>
                                );
                            })}
                            {!stagingSigned && (
                                <div className="text-[11px] text-[#687390] mt-2.5">
                                    Staging sign-off opens when every REQ item is ticked, and is recorded by someone other than the builder.
                                </div>
                            )}
                            <div className="text-[11px] text-[#aab3c8] mt-2.5">
                                {CHECKLIST_PROFILE} template{Number.isFinite(boundDay) ? ` · snapshot taken on entering QA, ${fmtDay(boundDay)}` : ''}
                            </div>

                            <div className="epm-plan__collapsible flat mt-3">
                                <div
                                    className={`epm-plan__collapsible-header relative ${stagingAuditOpen ? 'is-open' : ''}`}
                                    onClick={() => setStagingAuditOpen(!stagingAuditOpen)}
                                >
                                    <ChevronDown size={14} />
                                    <span className="epm-plan__collapsible-title text-xs">Activities</span>
                                    <span className="epm-plan__collapsible-subtitle text-[11px]">
                                        {stagingAudits.length} {stagingAudits.length === 1 ? 'event' : 'events'}
                                    </span>
                                    <span className="epm-plan__collapsible-action">
                                        {stagingAuditOpen ? 'Hide' : 'Show'}
                                    </span>
                                </div>
                                {stagingAuditOpen && (
                                    <div className="epm-plan__collapsible-body audit-table pt-2">
                                        <ChecklistAuditTable
                                            audits={stagingAudits}
                                            checklistLookup={checklistLookup}
                                            currentUserId={currentUserId}
                                            currentUserName={currentUserName}
                                        />
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default StagingChecklist;

